import { iSelectGame, iGameModel, iSelectGameType, iVirtualKeyboard, iGameAccount } from '@/interface/game-manage';
import request from '@/utils/request';
/**
 * 获取房间全局设置
 * @param params
 */
export const getRoomConfigSetting = (): Promise<any> =>
  request({
    url: '/api/v1/omc/room/global/setting',
  });

/*开启或关闭房间全局开关*/
export const updateRoomConfigOpen = (data: any): Promise<any> =>
  request({
    url: `/api/v1/omc/room/global/open`,
    method: 'PUT',
    data,
  });
/*开启或关闭房间全局开关*/
export const updateRoomConfigIdentify = (data: any): Promise<any> =>
  request({
    url: `/api/v1/omc/room/global/identify`,
    method: 'PUT',
    data,
  });

/**
 * 获取审核判定数
 * @param params
 * @returns
 */
export const getRoomIdentifyQuantity = (params: any): Promise<any> =>
  request({
    url: `/api/v1/omc/room/identify/quantity`,
    params,
  });

/**
 * 修改房间审核数量
 * @param data
 * @returns
 */
export const updateRoomIdentifyQuantity = (data: any): Promise<any> =>
  request({
    url: `/api/v1/omc/room/identify/quantity`,
    method: 'PUT',
    data,
  });

/**
 * 获取房间列表
 * @param data
 */
export const getRoomList = (params: any): Promise<any> =>
  request({
    url: `/api/v1/omc/room/list`,
    params,
  });
/**
 * 获取游戏房间数列表
 * @param data
 */
export const getRoomGameCountList = (params: any): Promise<any> =>
  request({
    url: `/api/v1/omc/room/game/count`,
    params,
  });

/*置顶房间*/
export const updateRoomTop = (data: any): Promise<any> =>
  request({
    url: `/api/v1/omc/room/top`,
    method: 'PUT',
    data,
  });
/*取消置顶房间*/
export const updateRoomTopCancel = (data: any): Promise<any> =>
  request({
    url: `/api/v1/omc/room/top/cancel`,
    method: 'PUT',
    data,
  });
/*房间（单个或批量）禁言/取消禁言*/
export const updateTextForbidden = (data: any): Promise<any> =>
  request({
    url: `/api/v1/omc/room/text/forbidden`,
    method: 'PUT',
    data,
  });
/*房间（单个或批量）关闭房间*/
export const updateRoomClose = (data: any): Promise<any> =>
  request({
    url: `/api/v1/omc/room/close`,
    method: 'PUT',
    data,
  });
/*数美告警*/
export const updateRoomIdentify = (params: any): Promise<any> =>
  request({
    url: `/api/v1/omc/room/identify`,
    params,
  });
